import { ref, onMounted } from 'vue';
import { api } from '@/server';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  name: 'DepCateSelect',
  setup(props, {
    emit
  }) {
    const depCateList = ref([]);
    const {
      runAsync: getDepCateList,
      loading,
      error
    } = fetchApi(api.kpi.depCate.getList);
    const fieldNames = {
      value: 'id',
      label: 'name'
    };
    const fetchData = async () => {
      const {
        error,
        rows = []
      } = await getDepCateList({
        count: -1
      });
      if (error) return;
      depCateList.value = rows;
    };
    onMounted(() => {
      fetchData();
    });
    return {
      fieldNames,
      depCateList,
      loading,
      error
    };
  }
};